import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "./apis/query-client";
import "./banner.css";
import { notificationDrawerStore } from "./hooks/store";
import "./index.css";
import { WasmProvider } from "./pages/Catering/WasmLoader";
import reportWebVitals from "./reportWebVitals";
import router from "./routes/index";
import Fonts from "./theme/Font";
import theme from "./theme/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WasmProvider>
        <ChakraProvider theme={theme}>
          <ColorModeScript initialColorMode={theme.config.initialColorMode} />
          <Fonts />
          <RouterProvider router={router} />
        </ChakraProvider>
      </WasmProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Register service worker for push notifications and badge management
if ("serviceWorker" in navigator && navigator.serviceWorker) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        // Service worker registered successfully
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener(
      "message",
      (event: MessageEvent) => {
        if (event.data && event.data.type === "NOTIFICATION_CLICKED") {
          // Use the notification drawer store
          notificationDrawerStore.isOpen = true;
        }
      }
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
